import React, { useMemo, useState } from 'react';
import Select from 'react-select';

const PAGE_SIZE = 200;

export const toBiomarkerGeneOptions = (genes) => (
  Array.isArray(genes) ? genes : []
).filter(gene => typeof gene === 'string' && gene.trim())
  .map(gene => ({ value: gene, label: gene }));

export default function BiomarkerGeneSelect({ options, ...props }) {
  const [inputValue, setInputValue] = useState('');
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
  // Search the entire API list before paging the menu, including Ensembl IDs.
  const matches = useMemo(() => {
    const query = inputValue.trim().toLowerCase();
    return options.filter(option => option.label.toLowerCase().includes(query));
  }, [options, inputValue]);

  return (
    <Select
      {...props}
      options={matches.slice(0, visibleCount)}
      inputValue={inputValue}
      onInputChange={(value) => {
        setInputValue(value);
        setVisibleCount(PAGE_SIZE);
      }}
      onMenuScrollToBottom={() => setVisibleCount(count => Math.min(count + PAGE_SIZE, matches.length))}
      captureMenuScroll
      filterOption={null}
    />
  );
}
